import constants from './constants';

const initState = {
  clients: null,
  clientsLoading: false,
  clientsError: null,

  users: null,
  usersCurrentClient: null,
  usersLoading: false,
  usersError: null,
};

function accountsReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.ACCOUNTS_CLIENTS_LOADING:
      return {
        ...state,
        clientsLoading: true,
      };

    case constants.ACCOUNTS_CLIENTS_ERROR:
      return {
        ...state,
        clientsError: payload,
        clientsLoading: false,
      };

    case constants.ACCOUNTS_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: payload,
        clientsLoading: false,
      };

    case constants.ACCOUNTS_SET_CLIENT:
      return {
        ...state,
        clients: payload,
      };

    case constants.ACCOUNTS_USERS_LOADING:
      return {
        ...state,
        usersLoading: true,
        users: null,
      };

    case constants.ACCOUNTS_USERS_ERROR:
      return {
        ...state,
        usersError: payload,
        usersLoading: false,
      };

    case constants.ACCOUNTS_USERS_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const { isSameCurrentClient, users } = payload;
      return {
        ...state,
        users,
        usersCurrentClient: isSameCurrentClient ? users : state.usersCurrentClient,
        usersLoading: false,
      };

    case constants.ACCOUNTS_SET_USER:
      return {
        ...state,
        users: payload,
      };

    case constants.ACCOUNTS_USE_USERS_CURRENT_CLIENT_AGAIN:
      return {
        ...state,
        users: state.usersCurrentClient,
      };

    default:
      return state;

  }

}

export default accountsReducer;
